import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef } from 'react';
import { ChipContainer, StyledAiBorderStackingOrderGuard, ChipContent, PrimaryLabel, SecondaryLabel } from './styled.js';
import { getTypographySize } from './utils.js';
import { jsx, jsxs } from 'react/jsx-runtime';

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var Chip = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var icon = props.icon,
    onClick = props.onClick,
    action = props.action,
    label = props.label,
    secondary = props.secondary,
    className = props.className,
    _props$size = props.size,
    size = _props$size === void 0 ? 'medium' : _props$size,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'solid' : _props$variant,
    _props$appearance = props.appearance,
    appearance = _props$appearance === void 0 ? 'primary' : _props$appearance,
    _props$wrap = props.wrap,
    wrap = _props$wrap === void 0 ? false : _props$wrap,
    rest = __rest(props, ["icon", "onClick", "action", "label", "secondary", "className", "size", "variant", "appearance", "wrap"]);
  var fontSize = getTypographySize(size);
  var containerProps = {
    onClick: onClick,
    as: onClick ? 'button' : 'div',
    type: onClick ? 'button' : undefined
  };
  return /*#__PURE__*/jsx(ChipContainer, _extends({
    $size: size,
    $variant: variant,
    $appearance: appearance,
    $wrap: wrap,
    className: className,
    ref: forwardedRef
  }, rest, {
    children: /*#__PURE__*/jsxs(StyledAiBorderStackingOrderGuard, {
      guard: appearance === 'ai' && variant === 'outline',
      children: [/*#__PURE__*/jsxs(ChipContent, _extends({}, containerProps, {
        children: [icon, label && /*#__PURE__*/jsx(PrimaryLabel, {
          $fontSize: fontSize,
          $fontWeight: "medium",
          $appearance: appearance === 'ai' ? 'ai' : undefined,
          children: label
        }), secondary && /*#__PURE__*/jsx(SecondaryLabel, {
          $truncate: true,
          $fontSize: fontSize,
          $appearance: "100",
          children: secondary
        })]
      })), action]
    })
  }));
});

export { Chip };
